function SessionSendRequest(path, message, recipient) {
    this.path = path;
    this.message = message;
    this.recipient = recipient;
}

module.exports = SessionSendRequest;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/send/session-send-request.js
// module id = 446
// module chunks = 1